<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BillingListItem"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.billingList.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcBillingListItemHeader
      :item="resource"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </UcBillingListItemHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      :readonly="resource.isReadOnly"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetBillingListItem
        :item="editor"
        :form="forms[formName]"
        @reload="evh_5534025912102772_reload($event, {})"
        @close="evh_5534025912102772_close($event, {})"
        @changed="evh_5534025912102772_changed($event, {})"
      >
      </FieldsetBillingListItem>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.register.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      class="ml-auto"
    >
      <ItpButton
        :form="forms[formName]"
        :text="'Create item'|pgettext('BillingListItem/Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="resource.isNew"
      >
      </ItpButton>
      <ItpButton
        :form="formId"
        :text="'Save changes'|pgettext('Button')"
        type="submit"
        :spinning="actions.save.isRunning"
        class="mr-2"
        v-if="!resource.isNew && !resource.isReadOnly && forms[formName]"
      >
      </ItpButton>
      <ItpButton
        :text="'Close'|gettext"
        variant="default"
        @click.prevent.stop="evh_2167826738365259_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingListItem extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getContainer(...args: any[]) {
    return {
      self: this.$fn.urlFor('create_billing_list_item'),
      object: 'list',
      data: []
    }
  }

  getPayload(...args: any[]) {
    const [editor] = args;
    const exclude = [];

    return editor.isNew ?
      editor.getData({ exclude }) :
      editor.getChanges({ exclude, skipEmbeddedLists: true })
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Object,
  })
  templateParams!: object;

  @Watch('templateParams')
  onTemplate_params(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("templateParams")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  messages!: any;
  resource!: any;

  async $$load_resource() {
    return this.oid
      ? this.$fn.fetch('read_billing_list_item', { parameters: { id: this.oid }, asResource: true })
      : this.$fn.fetch('get_billing_list_item_template', { parameters: this.templateParams, asResource: true })
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'messages', 'resource', 'editor', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "billingListItem",
        messages: {
          createTitle: this.$fn.pgettext("BillingListItem", "New billing list item"),
        }
        ,
        resource: null,
        editor: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get isDeletable() {
    if (this.loaded) {

      return this.oid != null
    }
    return null;
  }

  get editTitle() {
    if (this.loaded) {

      return this.resource.description
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.resource.isNew ? this.messages.createTitle : this.messages.editTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2100_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2100, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_2108_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_2108, alias=undefined
    return {
      grid: "billingListItem",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_emit_2112_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_2112, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async act_1040167445267876_closeComponent_2114_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2114, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_rest_2110_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_2110, alias=save
    return {
      method: "save",
      container: this.getContainer(this.editor),
      resource: this.editor,
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_emit_2120_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5534025912102772_emit_2120, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async evh_5534025912102772_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
  }

  async evh_2167826738365259_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2167826738365259_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2100: actions.CloseModalAction;
    evh_7315092382398562_close_2099: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2102: actions.CloseComponentAction;
    evh_2248226175642056_close_2101: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_2104: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_2103: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeComponent_2106: actions.CloseComponentAction;
    evh_8564662037462133_deleted_2105: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_2108: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_2107: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_emit_2112: actions.EmitAction;
    evh_1040167445267876_saved_2111: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_2114: actions.CloseComponentAction;
    evh_1040167445267876_saved_2113: actions.EventHandlerImpl;
    act_1040167445267876_rest_2110: actions.RestAction;
    evh_1040167445267876_submit_2109: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_reloadComponentData_2116: actions.ReloadComponentDataAction;
    evh_5534025912102772_reload_2115: actions.EventHandlerImpl;
    evh_5534025912102772_reload: actions.EventHandlerGroup;
    act_5534025912102772_closeComponent_2118: actions.CloseComponentAction;
    evh_5534025912102772_close_2117: actions.EventHandlerImpl;
    evh_5534025912102772_close: actions.EventHandlerGroup;
    act_5534025912102772_emit_2120: actions.EmitAction;
    evh_5534025912102772_changed_2119: actions.EventHandlerImpl;
    evh_5534025912102772_changed: actions.EventHandlerGroup;
    act_2167826738365259_closeComponent_2122: actions.CloseComponentAction;
    evh_2167826738365259_clickPreventStop_2121: actions.EventHandlerImpl;
    evh_2167826738365259_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2100 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2100_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2099 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2100,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2099],
      }
    );
    const act_2248226175642056_closeComponent_2102 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2101 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2102,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2101],
      }
    );
    const act_8564662037462133_reloadComponentData_2104 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_2103 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_2104,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_2103],
      }
    );
    const act_8564662037462133_closeComponent_2106 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_2105 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeComponent_2106,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_8564662037462133_reloadSlickgrid_2108 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_2108_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_2107 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_2108,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_2105, evh_8564662037462133_deleted_2107],
      }
    );
    const act_1040167445267876_emit_2112 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_2112_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_2111 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_2112,
        event: "saved",
        displayName: "emit",
      }
    );
    const act_1040167445267876_closeComponent_2114 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2114_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_2113 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2114,
        event: "saved",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_rest_2110 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_2110_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_saved_2111, evh_1040167445267876_saved_2113],
      }
    );
    const evh_1040167445267876_submit_2109 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_2110,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2109],
      }
    );
    const act_5534025912102772_reloadComponentData_2116 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_reload_2115 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadComponentData_2116,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5534025912102772_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_reload_2115],
      }
    );
    const act_5534025912102772_closeComponent_2118 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_close_2117 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_closeComponent_2118,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_5534025912102772_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_close_2117],
      }
    );
    const act_5534025912102772_emit_2120 = new actions.EmitAction(
      {
        actionArgs: this.act_5534025912102772_emit_2120_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_changed_2119 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_emit_2120,
        event: "changed",
        displayName: "emit",
      }
    );
    const evh_5534025912102772_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_changed_2119],
      }
    );
    const act_2167826738365259_closeComponent_2122 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2167826738365259_clickPreventStop_2121 = new actions.EventHandlerImpl(
      {
        action: act_2167826738365259_closeComponent_2122,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2167826738365259_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2167826738365259_clickPreventStop_2121],
      }
    );
    return {
      act_7315092382398562_closeModal_2100,
      evh_7315092382398562_close_2099,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2102,
      evh_2248226175642056_close_2101,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_2104,
      evh_8564662037462133_reload_2103,
      evh_8564662037462133_reload,
      act_8564662037462133_closeComponent_2106,
      evh_8564662037462133_deleted_2105,
      act_8564662037462133_reloadSlickgrid_2108,
      evh_8564662037462133_deleted_2107,
      evh_8564662037462133_deleted,
      act_1040167445267876_emit_2112,
      evh_1040167445267876_saved_2111,
      act_1040167445267876_closeComponent_2114,
      evh_1040167445267876_saved_2113,
      act_1040167445267876_rest_2110,
      evh_1040167445267876_submit_2109,
      evh_1040167445267876_submit,
      act_5534025912102772_reloadComponentData_2116,
      evh_5534025912102772_reload_2115,
      evh_5534025912102772_reload,
      act_5534025912102772_closeComponent_2118,
      evh_5534025912102772_close_2117,
      evh_5534025912102772_close,
      act_5534025912102772_emit_2120,
      evh_5534025912102772_changed_2119,
      evh_5534025912102772_changed,
      act_2167826738365259_closeComponent_2122,
      evh_2167826738365259_clickPreventStop_2121,
      evh_2167826738365259_clickPreventStop,
      save: act_1040167445267876_rest_2110,
    }
  }
}

Vue.component("BillingListItem", BillingListItem);

</script>